<template>
  <div>
    <offer-list :isManager="isManager"
                :offers="offerList"
                :currentPage="page"
                @offersPageChanged="pageChanged"
                @offersSortChanged="sortChanged">
    </offer-list>
  </div>
</template>

<script type="text/javascript">
  import offers_mixin from '@/mixin/offers'

  export default {
    mixins: [offers_mixin],
    name: 'OfferValidatedTable',
    props:['candidateId'],
    methods: {
      buildParams: function() {
        return {
          status:       'expired_and_validated',
          future:       false,
          page:         this.page,
          filters:      this.filters,
          sort_field:   this.offerList.sortField,
          sort_order:   this.offerList.sortOrder,
          candidate_id: this.candidateId
        }
      },
      initTab: function(){
        this.reloadOffers()
      },
      reloadOffers: function(){
        this.$store.dispatch('offers/loadOfferList', this.buildParams())
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/offers/OfferValidatedTable.vue